<template>
  <div>
    <div class="subtitle-1 pt-3 ps-3" style="background-color: #FFC107;">{{id}}</div>
    <div class="title pb-3 ps-3" style="background-color: #FFC107;">{{serialNumber}}</div>
    <div class="ps-3">Software version: <b>{{version}}</b></div>
    <div class="ps-3">Specs: <b>{{specs}}</b></div>
    <div class="ps-3">Connected: <b>{{connected ? 'Yes' : 'No'}}</b></div>
    <div class="ps-3">Opened by: <b>{{openedBy}}</b></div>
    <div class="ps-3">Open Date: <b>{{formatTime(openedOn)}}</b></div>
    <div class="ps-3">Caller's name: <b>{{callerName}}</b></div>
    <div class="ps-3">Caller's contact Info: <b>{{callerEmail}}</b></div>
    <div class="ps-3">Tech on site: <b>{{techOnSite ? 'Yes' : 'No'}}</b></div>
    <div class="ps-3">Demo, New Install, Transferred, or Owned: <b>{{disposition}}</b></div>
    <div class="ps-3">Customer has had unit for: <b>{{inService}}</b></div>
    <div class="ps-3">Issue description: <b>{{description}}</b></div>
    <div class="ps-3">Customer was doing: <b>{{circumstance}}</b></div>
    <div class="ps-3">Issue started on: <b>{{issueStartedOn}}</b></div>
    <div class="ps-3">Environment: <b>{{environment}}</b></div>
    <div class="ps-3">Is it currently happening: <b>{{exhibitingNow ? 'Yes' : 'No'}}</b></div>
    <div class="ps-3">Issue is reproducible: <b>{{reproducible ? 'Yes': 'No'}}</b></div>
    <div class="ps-3">What steps have been take to resolve the issue: <b>{{attemptedResolution}}</b></div>
    <div class="ps-3">Components replaced: <b>{{componentsReplaced}}</b></div>
    <div class="ps-3">Other: <b>{{other}}</b></div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    id: String,
    serialNumber: String,
    version: String,
    specs: String,
    connected: Boolean,
    openedBy: String,
    openedOn: String,
    callerName: String,
    callerEmail: String,
    techOnSite: Boolean,
    disposition: String,
    inService: String,
    description: String,
    circumstance: String,
    issueStartedOn: String,
    environment: String,
    exhibitingNow: Boolean,
    reproducible: Boolean,
    attemptedResolution: String,
    componentsReplaced: String,
    other: String,
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
